var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "KpiData_wrapper" },
    [
      _c(
        "el-tabs",
        {
          attrs: { type: "card" },
          model: {
            value: _vm.currView,
            callback: function($$v) {
              _vm.currView = $$v
            },
            expression: "currView"
          }
        },
        [
          _c("el-tab-pane", {
            attrs: { label: "阶段任务", name: "StageTask" }
          }),
          _c("el-tab-pane", {
            attrs: { label: "奖励金", name: "EmployeeBonus" }
          }),
          _c("el-tab-pane", { attrs: { label: "积分", name: "Integral" } }),
          _c("el-tab-pane", {
            attrs: { label: "品牌惩罚金", name: "BannerPunish" }
          }),
          _c("el-tab-pane", { attrs: { label: "排行榜", name: "RankList" } })
        ],
        1
      ),
      _c(
        "keep-alive",
        [
          _c(_vm.currView, {
            tag: "component",
            attrs: { activityID: _vm.activityID }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }